import { useState } from "react";
import GuideBanner from "../components/GuideBanner";
import Tooltip from "../components/Tooltip";
import { CLIENT_STAGES, FLEET_SIZES } from "../constants";
import { fmt } from "../utils";

const ITEMS_PER_PAGE = 20;

export default function ClientPipeline({ clients, today, setSelClient }) {
  const [expandedStages, setExpandedStages] = useState({});

  const getVisibleCount = (stageId) => expandedStages[stageId] || ITEMS_PER_PAGE;
  const showMore = (stageId) => setExpandedStages((prev) => ({ ...prev, [stageId]: (prev[stageId] || ITEMS_PER_PAGE) + ITEMS_PER_PAGE }));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <GuideBanner
        title="Pipeline — Acompanhe cada negociação"
        text="O pipeline mostra TODOS os leads em cada estágio. Mova o lead conforme a negociação avança clicando nas bolinhas de estágio dentro do card. Cada lead deve ter SEMPRE um próximo passo definido."
      />
      <div style={{ display: "flex", gap: 8, overflowX: "auto", paddingBottom: 8 }}>
        {CLIENT_STAGES.filter((s) => !["ganho", "perdido", "descartado"].includes(s.id)).map((stage) => {
          const sc = clients.filter((c) => c.stage === stage.id);
          const visibleCount = getVisibleCount(stage.id);
          const visibleItems = sc.slice(0, visibleCount);
          const hasMore = sc.length > visibleCount;
          return (
            <div key={stage.id} style={{ minWidth: 220, flex: "0 0 220px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 4px", marginBottom: 6 }}>
                <div style={{ width: 8, height: 8, borderRadius: 2, background: stage.color }} />
                <span style={{ fontSize: 11, fontWeight: 700, color: "#1e293b" }}>{stage.label}</span>
                <span style={{ fontSize: 10, color: "#94a3b8", background: "#f1f5f9", padding: "1px 4px", borderRadius: 3 }}>{sc.length}</span>
                <Tooltip text={stage.help} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6, minHeight: 50, background: "#f8fafc", borderRadius: 8, padding: 5 }}>
                {visibleItems.map((c) => {
                  const overdue = c.nextActionDate && c.nextActionDate < today;
                  return (
                    <div key={c.id} style={{ background: "#fff", borderRadius: 7, padding: 10, border: `1px solid ${overdue ? "#fecaca" : "#e5e7eb"}`, cursor: "pointer" }} onClick={() => setSelClient(c)}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#0f172a", marginBottom: 4 }}>{c.company}</div>
                      <div style={{ fontSize: 10, color: "#64748b", marginBottom: 6 }}>
                        {c.contact} • {FLEET_SIZES.find((f) => f.id === c.fleetSize)?.label || "?"}
                      </div>
                      {c.estimatedValue > 0 && (
                        <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>{fmt(c.estimatedValue)}</div>
                      )}
                      <div style={{ fontSize: 9, color: overdue ? "#ef4444" : "#94a3b8", fontWeight: overdue ? 600 : 400 }}>
                        {overdue ? "Atrasado — " : "→ "}{c.nextAction?.slice(0, 35)}
                      </div>
                    </div>
                  );
                })}
                {hasMore && (
                  <button onClick={() => showMore(stage.id)} style={{
                    padding: "6px 0", fontSize: 10, fontWeight: 600, color: "#7c3aed",
                    background: "none", border: "none", cursor: "pointer", textAlign: "center",
                  }}>
                    Ver mais ({sc.length - visibleCount} restantes)
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
